var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{class:[_vm.overrideColor]},[_c('div',{staticClass:"footer-font"},[_vm._v("© 2017- "+_vm._s(new Date().getFullYear())+" Global Psytech Sdn. Bhd.")])])
}
var staticRenderFns = []

export { render, staticRenderFns }